import { BookOpenText, Files, LibraryBig, MessageSquareText } from "lucide-react";
import { Link } from "react-router-dom";
import type { SearchGroup, SearchResult } from "../types";
import { EmptyState } from "./EmptyState";

const groupLabels: Record<SearchGroup, string> = {
  passport: "Паспорт проекта",
  facts: "Подтверждённые факты",
  wording: "Формулировки",
  assets: "Файлы",
};

const groupIcons = {
  passport: BookOpenText,
  facts: LibraryBig,
  wording: MessageSquareText,
  assets: Files,
};

export function SearchResults({ query, results, compact = false }: { query: string; results: SearchResult[]; compact?: boolean }) {
  if (!query.trim()) {
    return compact ? null : (
      <div className="search-prompt">
        <SearchResultHint />
      </div>
    );
  }

  if (results.length === 0) {
    return <EmptyState description="В базе пока нет подтверждённой информации по этому запросу." />;
  }

  const groups = (Object.keys(groupLabels) as SearchGroup[])
    .map((group) => ({ group, items: results.filter((item) => item.group === group) }))
    .filter(({ items }) => items.length > 0);

  return (
    <div className={`search-results ${compact ? "search-results--compact" : ""}`}>
      {groups.map(({ group, items }) => {
        const Icon = groupIcons[group];
        return (
          <section key={group} className="search-result-group">
            <div className="search-result-group__heading">
              <Icon size={17} aria-hidden="true" />
              <h2>{groupLabels[group]}</h2>
              <span>{items.length}</span>
            </div>
            <div className="search-result-list">
              {items.slice(0, compact ? 3 : undefined).map((item) => (
                <Link key={`${item.group}-${item.id}`} to={item.to} className="search-result-item">
                  <div>
                    <strong>{item.title}</strong>
                    <p>{item.excerpt}</p>
                    <small>{item.meta}</small>
                  </div>
                  <span aria-hidden="true">→</span>
                </Link>
              ))}
            </div>
          </section>
        );
      })}
      {compact && results.length > 6 && (
        <Link className="button button--secondary button--wide" to={`/search?q=${encodeURIComponent(query)}`}>
          Показать все результаты ({results.length})
        </Link>
      )}
    </div>
  );
}

function SearchResultHint() {
  return (
    <>
      <strong>Поиск по всей базе</strong>
      <p>Введите название, цифру, формат, источник, язык или тип файла.</p>
    </>
  );
}
